// extracted by mini-css-extract-plugin
export default {"myWorksBlock":"MyProject_myWorksBlock__rz5ty","myWorkContainer":"MyProject_myWorkContainer__O8SG7","work":"MyProject_work__kM7+c"};